import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
    Box, 
    Button, 
    Typography,
    Grid,
    IconButton,
    Menu,
    MenuItem,
    ListItemIcon,
    useMediaQuery,
} from '@mui/material';
import { Add, MoreVert } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../../resources/strings/StringKeys';
import AppSidebar from '../../../../components/navbar/DesktopAppSidebar';
import { CreateReviewTemplateModal } from './modals/CreateReviewTemplateModal';
import PerformanceReviewTemplatesTable from './PerformanceReviewTemplatesTable';
import { useUserContext } from '../../../../context/user_context/UserContext';
import { performanceReviewTemplatesSnapshotListener } from '../../../../repository/PerformanceReviewDAO';
import { handleMenuClick, handleMenuClose } from '../../../../components/utils/MenuHandlers';

const PerformanceReviewTemplates = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width:600px)');
    const [anchorEl, setAnchorEl] = useState(null);
    const [isTemplateModalOpen, setIsTemplateModalOpen] = useState(false);
    const [templates, setTemplates] = useState([]);
    const { firebaseUser } = useUserContext();

    useEffect(() => {
        if (firebaseUser) {
            const unsubscribe = performanceReviewTemplatesSnapshotListener(firebaseUser.organization, setTemplates);
            return () => unsubscribe();
        }
    }, [firebaseUser]);

    const handleEditTemplate = (templateId) => {
        navigate(`/performance-reviews/templates/${templateId}`);
    };

    const handleDuplicateTemplate = (templateId) => {
        // TODO: Implement duplicate
    };

    return (
        <AppSidebar
            content={
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12}>
                        <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                            {!isMobile && (
                                <>
                                    <Grid item>
                                        <Typography variant="h5">{t(StringKeys.REVIEW_TEMPLATES)}</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Grid container spacing={2} alignItems="center">
                                            <Grid item>
                                                <Button
                                                    variant="contained"
                                                    startIcon={<Add />}
                                                    onClick={() => setIsTemplateModalOpen(true)}
                                                >
                                                    {t(StringKeys.CREATE_REVIEW_TEMPLATE)}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </>
                            )}
                            {isMobile && (
                                <>
                                    <Grid item>
                                        <Typography variant="h6">{t(StringKeys.REVIEW_TEMPLATES)}</Typography>
                                    </Grid>
                                    <Grid item style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <IconButton onClick={(event) => handleMenuClick(event, setAnchorEl)}>
                                            <MoreVert />
                                        </IconButton>
                                        <Menu
                                            anchorEl={anchorEl}
                                            open={Boolean(anchorEl)}
                                            onClose={() => handleMenuClose(setAnchorEl)}
                                        >
                                            <MenuItem onClick={() => { 
                                                setIsTemplateModalOpen(true);
                                                handleMenuClose(setAnchorEl);
                                            }}>
                                                <ListItemIcon>
                                                    <Add />
                                                </ListItemIcon>
                                                {t(StringKeys.CREATE_REVIEW_TEMPLATE)}
                                            </MenuItem>
                                        </Menu>
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <PerformanceReviewTemplatesTable
                            templates={templates}
                            onEdit={handleEditTemplate}
                            onDuplicate={handleDuplicateTemplate}
                        />
                    </Grid>

                    <CreateReviewTemplateModal
                        open={isTemplateModalOpen}
                        onHide={() => setIsTemplateModalOpen(false)}
                    />
                </Grid>
            }
        />
    );
};

export default PerformanceReviewTemplates;
